import React, { useState, useEffect } from 'react';
import { DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

interface FloatingMobileButtonProps {
  onClick: () => void;
}

const FloatingMobileButton: React.FC<FloatingMobileButtonProps> = ({ onClick }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Определяем мобильное устройство
  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor;
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isSmallScreen = window.innerWidth <= 768;
      
      setIsMobile(isMobileDevice || (isTouchDevice && isSmallScreen));
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Автоскрытие на десктопе если открыта панель быстрых действий
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsVisible(true);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40">
      {/* Основная кнопка */}
      <button
        onClick={onClick}
        className={`w-16 h-16 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110 active:scale-95 ${
          isMobile 
            ? 'bg-orange-500 hover:bg-orange-600' 
            : 'bg-blue-500 hover:bg-blue-600'
        } text-white`}
        title={isMobile ? 'Быстрый ввод (Ctrl+M)' : 'Мобильный режим (Ctrl+M)'}
      >
        <DevicePhoneMobileIcon className="w-8 h-8" />
      </button>

      {/* Индикатор мобильного устройства */}
      {isMobile && (
        <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
          <span className="text-white text-xs font-bold">📱</span>
        </div>
      )}

      {/* Подсказка для первого использования */}
      <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 hover:opacity-100 transition-opacity pointer-events-none">
        {isMobile ? 'Быстрый ввод данных' : 'Мобильный интерфейс'}
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
      </div>

      {/* Пульсирующий эффект для привлечения внимания */}
      <div className={`absolute inset-0 w-16 h-16 rounded-full ${
        isMobile ? 'bg-orange-400' : 'bg-blue-400'
      } animate-ping opacity-20`}></div>
    </div>
  );
};

export default FloatingMobileButton;
